import { environment } from '../../environments/environment';
import Rollbar from 'rollbar';

/**
 * Inizializzazione di Rollbar allo startup dell'applicazione.
 * La funzione `transform`:
 * - aggiunge un fingerprint univoco (UUID) per impedire il raggruppamento automatico
 * - rimuove i dati `extra` dai trace interni della catena (trace_chain[1..n])
 *   per evitare che Rollbar li mostri come voci duplicate nell'UI
 */
export function rollbarFactory(): Rollbar {
  return new Rollbar({
    ...environment.rollbarConfig,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform: (data: any) => {
      data['fingerprint'] = crypto.randomUUID();

      const traceChain = data?.body?.trace_chain;
      if (Array.isArray(traceChain) && traceChain.length > 1) {
        for (let i = 1; i < traceChain.length; i++) {
          delete traceChain[i].extra;
        }
      }
    },
  });
}
